import styled from 'styled-components';
import { s } from './VIPReport.style';

const quantcheckData = [
  {
    strategy: '저평가주 (宙)',
    description: '시세보다 저렴하게 나온 물건',
    profit: '단기 매각 차익 가능성이 높음',
    applicable: '',
  },
  {
    strategy: '공시지가보다낮주 (宙)',
    description: '공시지가보다 낮은 가격에 매수 가능',
    profit: '공공가치보다 싸게 사는 안정성 높은 투자',
    applicable: '',
  },
  {
    strategy: '전세가보다낮주 (宙)',
    description: '전세보증금보다 싸게 매입 가능',
    profit: '실입주 없이 임대 수익 확보 가능',
    applicable: '',
  },
  {
    strategy: '평균보다낮주 (宙)',
    description: '인근 평균보다 낮은 가격의 물건',
    profit: '상대적 저평가 → 시세 회복 기대',
    applicable: '',
  },
  {
    strategy: '하자없주 (宙)',
    description: '권리상 하자 없음(대항력, 임차인 등)',
    profit: '법률 리스크 없이 깔끔한 낙찰 가능',
    applicable: '',
  },
  {
    strategy: '시세차익주 (宙)',
    description: '차익 실현 가능성이 높은 물건',
    profit: '중단기 매각으로 실현 가능한 수익 전략',
    applicable: '',
  },
  {
    strategy: '저평가부실채권주 (宙)',
    description: '시세보다 저렴한 NPL (부실채권) 물건',
    profit: '권리 분석만 통과하면 고수익 가능',
    applicable: '',
  },
  {
    strategy: '소액투자주 (宙)',
    description: '3천만 원 이하 소액 투자 가능',
    profit: '자금 부담 적고 초보자에게 적합',
    applicable: '',
  },
  {
    strategy: '시세상승주 (宙)',
    description: '최근 실거래가 상승세인 지역 물건',
    profit: '단기 시세 상승 기대감 + 매각 유리',
    applicable: '',
  },
  {
    strategy: '이자보다월세주 (宙)',
    description: '월세 수익 > 대출이자인 물건',
    profit: '레버리지 투자에서도 현금흐름 확보 가능',
    applicable: '',
  },
  {
    strategy: '전세우위주 (宙)',
    description: '전세 수요가 강한 지역 물건',
    profit: '공실 리스크 낮고 안정적인 임대 수익',
    applicable: '',
  },
  {
    strategy: '월세우위주 (宙)',
    description: '월세 임대수익이 유리한 지역 물건',
    profit: '이자 부담보다 높은 월 현금흐름 가능',
    applicable: '',
  },
];

const QuantCheck = () => {
  return (
    <s.Div style={{ paddingBottom: '120px' }}>
      <s.Title>📊퀀트 투자전략 해당 여부</s.Title>
      <CheckList>
        {quantcheckData.map((item, index) => (
          <CheckContainer key={index}>
            <ColumnContent>
              <RowContent>
                {item.strategy} {item.applicable}
              </RowContent>
              {item.description}
            </ColumnContent>

            <ProfitContainer>
              <img
                src="/assets/images/quant/diamond_20.svg"
                style={{ width: '20px', height: '20px' }}
              />
              {item.profit}
            </ProfitContainer>
          </CheckContainer>
        ))}
      </CheckList>
    </s.Div>
  );
};

export default QuantCheck;

const CheckList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const CheckContainer = styled.div`
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-radius: 16px;
  border: 1px solid #e5e8ea;
`;

const RowContent = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #008aff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const ColumnContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 13px;
  font-weight: 500;
  color: #616161;
`;

const ProfitContainer = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: #222222;
  display: flex;
  flex-direction: row;
  gap: 4px;
  border-radius: 8px;
  padding: 8px;
  background-color: rgba(112, 115, 124, 0.08);
  align-items: center;
`;
